<template>
    <div role="tabpanel" class="tab-pane" id="tabs-files-attachment">
        <div class="addInHiddenInView">
            <!-- Conditional Rendering for Upload Button based on itemType and Authorization -->
            <div v-if="shouldShowUploadButton" class="tabs_button">
                <b>
                    <a
                        class="black_color upper"
                        href="#"
                        @click.prevent="openUploadPopup"
                    >Upload Files &nbsp;<span class="fa fa-upload"></span></a>
                </b>
            </div>
        </div>

        <div id="attachment-info">
            <div class="tab_padding float_none" v-if="hasAttachmentsOrSignatures">
                <table class="table table-bordered">
                    <thead>
                    <tr class="header-details-summary">
                        <th><b>Date</b></th>
                        <th><b>Attachment</b></th>
                        <th><b>Description</b></th>
                        <th><b>Size</b></th>
                        <th><b>Uploaded With</b></th>
                        <th><b>User</b></th>
                    </tr>
                    </thead>
                    <tbody>
                    <!-- Loop for Customer Signatures -->
                    <tr v-for="signature in customerSignatures" :key="signature.id">
                        <td>{{ formatDate(signature.date) }}</td>
                        <td>
                            <a v-if="credentials.canDownloadAttachment" :href="signature.downloadUrl" class="details_info_opt">{{ signature.fileName }}</a>
                            <span v-else>{{ signature.fileName }}</span>
                        </td>
                        <td>{{ signature.description }}</td>
                        <td>{{ signature.size }}</td>
                        <td>-</td>
                        <td>{{ signature.user }}</td>
                    </tr>
                    <!-- Loop for Booking Attachments -->
                    <tr v-for="attachment in bookingAttachments" :key="attachment.id">
                        <td>{{ formatDate(attachment.date) }}</td>
                        <td>
                            <a v-if="credentials.canDownloadAttachment" :href="attachment.downloadUrl" class="details_info_opt">{{ attachment.fileName }}</a>
                            <span v-else>{{ attachment.fileName }}</span>
                        </td>
                        <td>
                            <a href="#" @click="viewAttachmentDescription(attachment)">
                                {{ truncate(attachment.description, 50) }}
                            </a>
                        </td>
                        <td>{{ attachment.size }}</td>
                        <td>{{ attachment.uploadedWith }}</td>
                        <td>{{ attachment.user }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div v-else class="inquiry-no-result">

                <br/>
                <h3 class="font-bold"><span class="fa fa-ban"></span> No attachments uploaded</h3>
            </div>
        </div>
    </div>
</template>

<script>
import {getSingleTabData} from "@/modules/Booking/api/BookingViewTabs";

export default {
    name: "AttachmentsTab",
    props:{

        itemType: {
            type: String,
            required: true
        },
        itemId: {
            type: Number,
            required: true
        },
        credentials: {
            type: Object,
            default: () => ({}) // Default value is an empty object
        },
        view:'booking',
    },
    data() {
        return {
            bookingIsDeleted: false,
            inquiryIsDeleted: false,
            bookingAttachments: [],
            customerSignatures: [],
            dateTimeObj:null

        };
    },

    computed: {
        shouldShowUploadButton() {
            return (
                (this.itemType === 'booking' || this.itemType === 'estimate' || this.itemType === 'invoice') &&
                this.credentials.attachmentFileUpload &&
                !this.bookingIsDeleted
            ) || (
                this.itemType === 'inquiry' &&
                this.credentials.attachmentFileUpload &&
                !this.inquiryIsDeleted
            );
        },
        hasAttachmentsOrSignatures() {
            return this.bookingAttachments.length > 0 || this.customerSignatures.length > 0;
        },
    },
    methods: {
        openUploadPopup() {
            // Implement popup logic here
        },
        viewAttachmentDescription(attachment) {
            // Implement view description logic here
        },
        formatDate(dateString) {
            // Implement date formatting logic here
        },
        truncate(text, length) {
            return text.length > length ? text.substring(0, length) + '...' : text;
        },
        fetchData(){
                let params = {
                    type: "attachments",
                    inquiry_id: this.itemId,
                    fromVuejs:true
                }
                getSingleTabData(params).then((response) => {
                    this.bookingAttachments = response.data.bookingAttachments;
                    this.bookingId = response.data.bookingId;
                    this.customerSignatures = response.data.customerSignatures;
                    this.dateTimeObj = response.data.dateTimeObj;
                })
        }
    },
    mounted() {
        this.fetchData();
    },

}
</script>
<style scoped>

</style>